import type { RouteRecordRaw } from 'vue-router';

// 路由表：禁止任何浏览器副作用 import（无 css / 无进度条 / 无 window 逻辑）。
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('../views/home/index.vue'),
  },
  {
    path: '/cases',
    component: () => import('../views/cases/index.vue'),
    props: route => ({ keyword: route.query.keyword }),
    meta: {
      title: '案例库',
    },
  },
  {
    path: '/cases/:id',
    component: () => import('../views/cases/detail.vue'),
    props: true,
    meta: {
      title: '司法案例',
    },
  },
  {
    path: '/experts',
    component: () => import('../views/experts/index.vue'),
    meta: {
      title: '社区贡献者',
    },
  },
  {
    path: '/experts/:id',
    component: () => import('../views/experts/detail.vue'),
    props: true,
    meta: {
      title: '贡献者详情',
    },
  },
  {
    path: '/faq/:id',
    component: () => import('../views/faq/detail.vue'),
    props: true,
    meta: {
      title: '常见问题',
    },
  },
  {
    path: '/news',
    component: () => import('../views/news/index.vue'),
    meta: {
      title: '社区资讯',
    },
  },
  {
    path: '/news/:id',
    component: () => import('../views/news/detail.vue'),
    props: true,
    meta: {
      title: '资讯详情',
    },
  },
  // 专区体系：路由段与后端 zoneCode 一致（ai / legal-topics / salons / licenses / translations），
  // 问答专区后端 url 为 /questions，单独成段
  {
    path: '/questions',
    component: () => import('../views/zones/qa/index.vue'),
    meta: {
      title: '提问讨论版',
    },
  },
  {
    path: '/questions/:id',
    component: () => import('../views/zones/qa/detail.vue'),
    props: true,
    meta: {
      title: '问题详情',
    },
  },
  {
    path: '/courses',
    component: () => import('../views/courses/index.vue'),
    meta: {
      title: '开源法律课程',
    },
  },
  {
    path: '/courses/collection/:id',
    component: () => import('../views/courses/collection.vue'),
    props: true,
    meta: {
      title: '课程合集',
    },
  },
  {
    path: '/zones/:zone',
    component: () => import('../views/zones/common/index.vue'),
    props: true,
    meta: {
      title: '专区',
    },
  },
  {
    path: '/zones/:zone/article/:id',
    component: () => import('../views/zones/common/article.vue'),
    props: true,
    meta: {
      title: '文章详情',
    },
  },

  // {
  //   path: '/policy/privacy',
  //   component: () => import('../views/content-viewer/index.vue'),
  //   props: {
  //     configKey: 'site.privacyPolicy',
  //     title: '隐私声明',
  //   },
  //   meta: {
  //     title: '隐私声明',
  //   },
  // },
  {
    path: '/policy/code-of-conduct',
    component: () => import('../views/content-viewer/index.vue'),
    props: {
      configKey: 'site.codeOfConduct',
      title: '社区行为守则',
    },
    meta: {
      title: '社区行为守则',
    },
  },
  {
    path: '/callback',
    component: () => import('../views/auth/callback.vue'),
    props: route => ({
      code: route.query.code,
      from: route.query.from,
    }),
  },

  // 注意：404 路由，业务路由都要放在这前面
  {
    name: 'notFound',
    path: '/404',
    component: () => import('../views/common/404.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('../views/common/404.vue'),
  },
];
